// extracted by mini-css-extract-plugin
module.exports = {"content":"HtmlContent_content__RY5p6"};